import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {GridServiceResponse} from 'src/app/shared/model/page-grid';
import {AdxSbDailyReconciliation} from '../model/adx-sb-daily-reconciliation';

/**
 * Plain service used by the dashboard component to fetch the daily reconciliation
 * rows for the KPI summary cards (the grids use their own GridGetService).
 */
@Injectable({
  providedIn: 'root'
})
export class AdxSbReconciliationService {
  private readonly http = inject(HttpClient);

  public getDaily(from: string, to: string, dateBasis: string): Observable<GridServiceResponse<AdxSbDailyReconciliation>> {
    const params = new HttpParams({
      fromObject: {
        from,
        to,
        dateBasis: dateBasis || 'Issue',
        pageNumber: 1,
        pageSize: 500,
        propertyName: 'day',
        orderKey: 'asc',
      }
    });

    return this.http.get<GridServiceResponse<AdxSbDailyReconciliation>>('dbov2/adx-sb-reconciliation/daily', {params})
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => new Error(error?.message || 'Server error'))));
  }
}
